import { useContext } from "react";
import Playground from "../components/desktop/Playground";
import ProgressIndicator from "../components/common/ProgressIndicator";

import { GameContext } from "../context/GameContext";

const GameView = () => {
  const {
    setCurrentQuestion,
    deskQuest,
    setDeskQuest,
    checkAlreadyAnswerd,
    userAnswer,
    restartGame,
  } = useContext(GameContext);

  const getId = (id, e) => {
    if (e.target.dataset.id) {
      setCurrentQuestion(id);
      checkAlreadyAnswerd(id);
      if (!deskQuest) {
        setDeskQuest(!deskQuest);
      }
    }
  };

  return (
    <>
      <main className="container">
        <div className="page">
          <Playground />
        </div>
      </main>
      <ProgressIndicator onClick={getId} />
      {userAnswer.length > 0 && !deskQuest ? (
        <div className="reset_container">
          <button className="restart_button" onClick={() => restartGame()}>
            Börja om
          </button>
        </div>
      ) : null}
    </>
  );
};

export default GameView;
